const {
  REACT_APP_CHATBOT_API_URL
} = process.env

const config = {
  chatbot_url: REACT_APP_CHATBOT_API_URL
}

export {config}
